// extracted by mini-css-extract-plugin
export default {"statisticItem":"StatisticItem_statisticItem__2PRbZ","statisticItemCount":"StatisticItem_statisticItemCount__w+kz+","statisticItemText":"StatisticItem_statisticItemText__V3g+j"};